import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_nsti_stock_txn_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
    guid_generic_doc_line: fromDatatype.GuidDataFieldInterface;
    guid_bl_fi_mst_entity_hdr: fromDatatype.GuidDataFieldInterface;
    guid_fi_mst_item: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    amount_std: fromDatatype.NumericDatatypeInterface;
    amount_net: fromDatatype.NumericDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    tax_gst_code: fromDatatype.VarcharDatatypeInterface;
    tax_gst_type: fromDatatype.VarcharDatatypeInterface;
    tax_gst_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    tax_wht_code: fromDatatype.VarcharDatatypeInterface;
    tax_wht_type: fromDatatype.VarcharDatatypeInterface;
    tax_wht_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_wht: fromDatatype.NumericDatatypeInterface;
    amount_json: fromDatatype.JsonDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    quanitity_signum: fromDatatype.NumericDatatypeInterface;
    quantity_base: fromDatatype.NumericDatatypeInterface;
    base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
    base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
    doc_ccy: fromDatatype.VarcharDatatypeInterface;
    amount_discount: fromDatatype.NumericDatatypeInterface;
    amount_open_balance: fromDatatype.NumericDatatypeInterface;
    unit_price_net: fromDatatype.NumericDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    nsti_stock_hdr_guid: fromDatatype.GuidDataFieldInterface;
    serial_no_json: fromDatatype.JsonDatatypeInterface;
    line_property_json: fromDatatype.JsonDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_nsti_stock_txn_line_RowClass implements bl_fi_nsti_stock_txn_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_generic_doc_hdr: fromDatatype.GuidDataFieldInterface;
    guid_generic_doc_line: fromDatatype.GuidDataFieldInterface;
    guid_bl_fi_mst_entity_hdr: fromDatatype.GuidDataFieldInterface;
    guid_fi_mst_item: fromDatatype.GuidDataFieldInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    guid_branch: fromDatatype.GuidDataFieldInterface;
    guid_store: fromDatatype.GuidDataFieldInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    amount_std: fromDatatype.NumericDatatypeInterface;
    amount_net: fromDatatype.NumericDatatypeInterface;
    amount_txn: fromDatatype.NumericDatatypeInterface;
    tax_gst_code: fromDatatype.VarcharDatatypeInterface;
    tax_gst_type: fromDatatype.VarcharDatatypeInterface;
    tax_gst_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_gst: fromDatatype.NumericDatatypeInterface;
    tax_wht_code: fromDatatype.VarcharDatatypeInterface;
    tax_wht_type: fromDatatype.VarcharDatatypeInterface;
    tax_wht_rate: fromDatatype.NumericDatatypeInterface;
    amount_tax_wht: fromDatatype.NumericDatatypeInterface;
    amount_json: fromDatatype.JsonDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    quanitity_signum: fromDatatype.NumericDatatypeInterface;
    quantity_base: fromDatatype.NumericDatatypeInterface;
    base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
    base_doc_line_xrate: fromDatatype.NumericDatatypeInterface;
    doc_ccy: fromDatatype.VarcharDatatypeInterface;
    amount_discount: fromDatatype.NumericDatatypeInterface;
    amount_open_balance: fromDatatype.NumericDatatypeInterface;
    unit_price_net: fromDatatype.NumericDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    nsti_stock_hdr_guid: fromDatatype.GuidDataFieldInterface;
    serial_no_json: fromDatatype.JsonDatatypeInterface;
    line_property_json: fromDatatype.JsonDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    server_doc_no: fromDatatype.VarcharDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface
}
